import { createSvgIcon } from '@mui/material';
import Styled from './custom-styled-icon'
import React from 'react'

export const PaymentRequest = Styled(
	createSvgIcon(
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M6.33301 9.16667C6.33301 9.81333 6.83302 10.3333 7.44635 10.3333H8.69967C9.233 10.3333 9.66634 9.88 9.66634 9.31333C9.66634 8.70667 9.39968 8.48667 9.00635 8.34667L6.99967 7.64667C6.60634 7.50667 6.33968 7.29334 6.33968 6.68C6.33968 6.12 6.773 5.66 7.30634 5.66H8.55967C9.17301 5.66 9.67301 6.18 9.67301 6.82667"
				stroke="currentColor"
				stroke-width="1.2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path d="M8 5V11" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
			<path
				d="M14.6663 8.00001C14.6663 11.68 11.6797 14.6667 7.99967 14.6667C4.31967 14.6667 1.33301 11.68 1.33301 8.00001C1.33301 4.32001 4.31967 1.33334 7.99967 1.33334"
				stroke="currentColor"
				stroke-width="1.2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M11.333 2V4.66667H13.9997"
				stroke="currentColor"
				stroke-width="1.2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M14.6663 1.33334L11.333 4.66668"
				stroke="currentColor"
				stroke-width="1.2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>,
		'PaymentRequest'
	)
)

export default PaymentRequest
